import { ClassNames } from '@emotion/react';
import { i18n } from '@/i18n';
import {
  RichTextEditor,
  type RichTextEditorProps,
} from '@/pages/Schedule/components';
import './styles.scss';

type Props = Omit<RichTextEditorProps, 'ref'>;

export const DescriptionInput = ({
  id = 'entry-modal-description',
  placeholder = i18n.t('entryModal:description.placeholder'),
  className,
  ...props
}: Props) => {
  return (
    <ClassNames>
      {({ cx }) => (
        <RichTextEditor
          className={cx('entry-modal-description', className)}
          id={id}
          placeholder={placeholder}
          {...props}
        />
      )}
    </ClassNames>
  );
};
